import React from 'react';
import { Form, Input, Button,Spin,Select,Switch,Divider } from 'antd';
import axios from 'axios'
import * as serverconfig from '../serverconn'
import { UserOutlined, LockOutlined, LoadingOutlined, MailOutlined,UploadOutlined } from '@ant-design/icons';
import moment from 'moment';

var CryptoJS = require("crypto-js");

const FormItem=Form.Item;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

var token= ''
var username=''
const dateFormat = 'DD/MM/YYYY';
const { TextArea } = Input;

const { Option } = Select;

class ActionWorkFlowMappingForm extends React.Component {

  state = {
    name:'' ,  
    datarequested:true,
    workflow_type:'',
    active:false,
    description:'',
    abbreviation:'',

    actions:[],
    action:'',

    staff_roles:[],
    responsible_roles:[],


  }

  componentDidMount(){   
    this.component_reloaded()
  }


  component_reloaded=()=>{
    this.setState({datarequested:true})

    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }

    if(localStorage.getItem("username")){
      username= CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)
   
   }else{
      username=''
   }


    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }


    axios.get(serverconfig.backendserverurl+`/api/actions/`)
    .then(res => {
        this.setState({
          actions:res.data
        })
      })

    axios.get(serverconfig.backendserverurl+`/api/staff_roles/`)
    .then(res => {
        this.setState({
          staff_roles:res.data
        })
  
        this.setState({datarequested:false})
    })



  }


  //submit button pressed
  handleFormSubmit=(event) =>{
    this.setState({datarequested:true})
    let form_data = new FormData();
    form_data.append('action', this.state.action);
    form_data.append('responsible_roles',JSON.stringify(this.state.responsible_roles) );
    form_data.append('workflow', this.props.workflow_id);

    axios.post(serverconfig.backendserverurl+'/api/actionworkflowmappings/', form_data, {
      headers: {
        'content-type': 'multipart/form-data'
      }
    })
  .then(res => {
    this.setState({responsible_roles:[]})
    this.setState({action:''})

    this.setState({datarequested:false})
    this.component_reloaded()

    ///refesrh
    this.props.onRefresh()

  }    

  )
  .catch(error => console.log(error))

  }

  
  render(){

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )

    }else{
      return (
     <div>
    <Form onFinish={(event) => this.handleFormSubmit(event)}>

   <FormItem label="Action"
        name="action"
        rules={[
          {
            required: true,
            message: 'Please select',
          },
        ]}
      >
          <Select 
          placeholder="Action" 
          style={{  }} 
          value={this.state.action}
          onChange={(val)=>{
            this.setState({action:val})
          }} 
          showSearch
          optionFilterProp="children"
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          onSearch={this.onSearch}   
          >
            {this.state.actions.map(
              (type)=>(
                <Option value={type.id}>{type.name}</Option>
              ))}
          </Select>
      </FormItem>

       {
            this.state.staff_roles.length>0?
            <div style={{display:'flex',flexDirection:'column'}}>
            <h6>Responsible Roles for the action.</h6>

            {this.state.staff_roles.map((item) => (
              <p style={{display:'flex',flexDirection:'row'}}>
              <Switch
                onChange={(val) => {
                  if (val === true) {
                   
                    var new_array = [
                      ...this.state.responsible_roles,
                      item.name,
                    ];
                    this.setState({ responsible_roles: new_array });
                  } else {
                    this.setState({
                      responsible_roles: [
                        ...this.state.responsible_roles.filter(
                          (todo) => todo!== item.name
                        ),
                      ],
                    });
                  }
                  
                }}
                style={{marginRight:2}} 

              ></Switch>{" "}
              {item.name} 
            </p>

            ))}

            <Divider></Divider>
            </div>
            :
            null
          }

      <FormItem>
        <Button  type="primary" htmlType="submit">Add Action</Button>
      </FormItem>
       </Form>
        </div>
      );
    }

  }

}


export default ActionWorkFlowMappingForm;



